import styled, { css } from 'styled-components';
import { BlackButton } from '../../../baseComponents/button/Button';
import {
  TypographyStyles,
  colours,
  focusOutline,
  media,
  spacing,
  zPriceTooltip,
  zPriceTooltipArrow,
} from '../../../stylings';

export const TaxesContainer = styled.div<{ $isAllowedLocale: boolean }>`
  display: ${({ $isAllowedLocale }) => ($isAllowedLocale ? 'block' : 'none')};
`;

export const TaxAccordion = styled.div`
  all: inherit;
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
`;

export const TaxLabel = styled.div`
  align-items: center;
  display: flex;
  gap: 6px;
`;

export const EstimateButton = styled.button`
  ${TypographyStyles.Body.Small.SemiBold}
  align-items: center;
  background-color: transparent;
  border: none;
  color: ${colours.BLACK};
  cursor: pointer;
  display: flex;
  gap: ${spacing.XXXXS};
  padding: 0;
  user-select: none;
`;

export const TotalTaxPrice = styled.span<{ $showTotalTaxPrice: boolean; $isCheckoutPage?: boolean }>`
  display: ${({ $showTotalTaxPrice }) => ($showTotalTaxPrice ? 'block' : 'none')};
  ${({ $isCheckoutPage }) =>
    $isCheckoutPage &&
    css`
      ${TypographyStyles.Body.Small.SemiBold}
      &:focus-visible {
        outline: 2px solid ${colours.OUTLINE_BORDER};
      }
    `}
`;

export const TooltipButtonContainer = styled.button`
  all: initial;
  cursor: pointer;
  &:focus {
    ${focusOutline}
  }
`;

export const TaxTooltipBubble = styled.div`
  ${TypographyStyles.Body.Tiny.Regular}
  background: ${colours.WHITE};
  filter: drop-shadow(0 0 1px ${colours.BLACK});
  max-width: 300px;
  padding: 20px;
  width: auto;
  z-index: ${zPriceTooltip};

  &[data-popper-placement^='top'] > .arrow {
    bottom: 25px;
  }

  &[data-popper-placement^='bottom'] > .arrow {
    top: 25px;
  }

  @media ${media.greaterThan('lg')} {
    width: 300px;
  }
`;

export const TaxTooltipArrow = styled.div`
  margin-left: -15px;
  position: absolute;
  z-index: ${zPriceTooltipArrow};

  &:before,
  &:after {
    border: 20px solid transparent;
    bottom: 0;
    content: '';
    position: absolute;
  }

  &:before {
    border-bottom: 30px solid ${colours.WHITE};
    border-top: 0;
    bottom: 20px;
    left: -4px;
  }

  &:after {
    border-bottom: 0;
    border-top: 30px solid ${colours.WHITE};
    left: -4px;
    top: 15px;
  }
`;

export const AccordionContainer = styled.div<{ $isAccordionOpen: boolean }>`
  align-items: center;
  display: ${({ $isAccordionOpen }) => ($isAccordionOpen ? 'flex' : 'none')};
  flex-direction: column;
  margin-top: ${spacing.XXXS};
`;

export const InputContainer = styled.form`
  display: flex;
  width: 100%;
`;

export const TaxInput = styled.input<{ $isInputError: boolean }>`
  ${TypographyStyles.Body.Medium.Regular}
  border: ${({ $isInputError }) => ($isInputError ? 'none' : `1px solid ${colours.BLACK}`)};
  margin-right: ${spacing.XXXS};
  outline: ${({ $isInputError }) => ($isInputError ? `1px solid ${colours.RED}` : 'none')};
  padding: ${spacing.XXXS} ${spacing.XXS};
  width: 100%;

  @media ${media.greaterThan('lg')} {
    max-width: 240px;
  }

  &::placeholder {
    color: ${colours.GREY};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
`;

export const TaxEstimateButton = styled(BlackButton)`
  height: auto;
  margin: 0;
  padding: ${spacing.XXS} ${spacing.S};

  &:disabled {
    background-color: ${colours.LIGHT_GREY_2};
    border: 1px solid ${colours.GREY};
    color: ${colours.GREY};
    cursor: not-allowed;
  }
`;

export const InputErrorMessage = styled.span`
  ${TypographyStyles.Body.Tiny.Medium}
  color: ${colours.ERROR_PRIMARY};
  margin-top: ${spacing.XXXS};
`;
